var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{attrs:{"button-class":"button-primary"},on:{"onClick":_vm.openSignatureModal}},[_vm._v("Confirm")])}
var staticRenderFns = []

export { render, staticRenderFns }